import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import BrandOption1 from './pages/BrandOption1';
import BrandOption2 from './pages/BrandOption2';
import BrandOption3 from './pages/BrandOption3';
import BrandOption4 from './pages/BrandOption4';
import FieldStyle from './pages/FieldStyle';
import RushStyle from './pages/RushStyle';
import NCLive from './pages/NCLive';
import NCReplays from './pages/NCReplays';
import Watch from './pages/Watch';
import Login from './pages/Login';
import Register from './pages/Register';
import MyStreams from './pages/MyStreams';
import BrowserStream from './pages/BrowserStream';
import AdminDashboard from './pages/admin/Dashboard';
import AdminGames from './pages/admin/Games';
import AdminUsers from './pages/admin/Users';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

// SWITCH BETWEEN BRAND OPTIONS HERE:
// 1 = APEX SPORTS  (blue, athletic)
// 2 = VOLT LIVE    (yellow, electric)
// 3 = PRIME STREAM (purple/white, sophisticated)
// 4 = SURGE SPORTS (blue/green gradient)
// 5 = FIELD        (editorial magazine — forest green + cream + gold)
// 6 = RUSH         (aggressive diagonal — black + red, Red Bull meets Nike)
const ACTIVE_BRAND = 7;

const BrandComponents = { 1: BrandOption1, 2: BrandOption2, 3: BrandOption3, 4: BrandOption4, 5: FieldStyle, 6: RushStyle, 7: NCLive };
const Home = BrandComponents[ACTIVE_BRAND];

function App() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    // For local development, use deployed AWS resources
    if (process.env.NODE_ENV === 'development') {
      setConfig({
        apiUrl: 'https://gcmn6060ac.execute-api.ap-northeast-1.amazonaws.com/dev/',
        userPoolId: 'ap-northeast-1_ZiKdwrztt',
        userPoolClientId: 'pumg7sopvaqno929uorg6i81r',
        region: 'ap-northeast-1',
        ivsRegion: 'ap-northeast-1',
      });
    } else {
      fetch('/config.json')
        .then(res => res.json())
        .then(setConfig)
        .catch(console.error);
    }
  }, []);

  if (!config) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <AuthProvider config={config}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout config={config} />}>
            <Route index element={<Home config={config} />} />
            <Route path="replays" element={<NCReplays config={config} />} />
            <Route path="watch/:gameId" element={<Watch config={config} />} />
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            
            <Route path="my-streams" element={
              <ProtectedRoute requireAuth>
                <MyStreams config={config} />
              </ProtectedRoute>
            } />
            

            <Route path="stream/:gameId/browser" element={
              <ProtectedRoute requireAuth>
                <BrowserStream config={config} />
              </ProtectedRoute>
            } />
            
            <Route path="admin" element={
              <ProtectedRoute requireAdmin>
                <AdminDashboard config={config} />
              </ProtectedRoute>
            } />
            
            <Route path="admin/games" element={
              <ProtectedRoute requireAdmin>
                <AdminGames config={config} />
              </ProtectedRoute>
            } />
            
            <Route path="admin/users" element={
              <ProtectedRoute requireAdmin>
                <AdminUsers config={config} />
              </ProtectedRoute>
            } />
            
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
